export default {
  methods: {
    verifyPairs(data, from, topic = "") {
      let msg = ""
      if (from === "add") msg = "请将已有的 key-value 信息填写完整后再添加"
      else if (from === "submit") msg = `请将${topic}已有的 key-value 信息填写完整后再提交`
      for (let item of data) {
        if (!item.code || !item.sheetVar) {
          this.$message.warning(msg)
          return false
        }
      }
      if (from === "submit") {
        let keys = data.map(i => i.code)
        if (keys.length !== new Set(keys).size) {
          this.$message.error("不能存在重复的key，请删掉多余的之后再提交")
          return false
        }
      }
      return true
    }
  }
}
